import React from 'react';
import { useLocation } from 'react-router-dom';

import { FamAccountPicker } from 'foodAsMedicineComponents/shared/nav/components/famAccountPicker';

import './header.css';

function Header() {
    const location = useLocation();

    return (
        <div className="fam-header">
            <img src="https://static.misfitsmarket.com/images/MM_nav-logo-desktop.svg" alt="Logo" />
            <span className="fam-partnerships-tag">Partnerships</span>
            <FamAccountPicker readOnly={!location.pathname.includes('/orders')} />
        </div>
    );
}

export { Header };
